<template>
<aside class="page-sidebar page-sidebar-fixed">
  <slot name="before"/>
  <div class="page-sidebar__main">
    <router-link :to="{ name: 'home' }" class="page-sidebar-logo">
      <img :src="headerLogo" alt="">
    </router-link>
    <Simplebar class="page-sidebar-menu">
      <slot name="categories" v-bind="{ visibleCategoriesTree }"/>
      <template v-if="hasMainMenuLinks">
        <hr class="page-sidebar__categories-and-links-divider">
        <router-link
          v-for="mainMenuLink in mainMenuLinks"
          :key="`base-main-menu-link-to-${mainMenuLink.to.name}`"
          :to="mainMenuLink.to"
          class="page-sidebar__other-link"
        >{{ mainMenuLink.text }}</router-link>
      </template>
    </Simplebar>
    <footer v-if="socials.length > 0" class="sidebar-footer">
      <SocialsList />
    </footer>
  </div>
</aside>
</template>

<script>
import { mapGetters } from 'vuex';
import AsyncSimplebar from '@/components/AsyncSimplebar.js';
import HasMainMenuLinks from "@/mixins/HasMainMenuLinks";
import SocialsList from '@/components/socials/SocialsList.vue';

export default {
  components: {
    Simplebar: AsyncSimplebar,
    SocialsList,
  },

  mixins: [HasMainMenuLinks],

  computed: {
    ...mapGetters({
      visibleCategoriesTree: 'catalog/visibleCategoriesTree',
      socials: 'store/activeCitySocials',
      headerLogo: 'settings/headerLogo',
    }),
  },
}
</script>

<style lang="less">
.page-sidebar {
  &.page-sidebar-fixed {
    @apply fixed left-0 inset-y-0 z-sidebar max-h-screen;
    width: theme('customVars.sidebar.width');
  }

  &__main {
    @apply h-full flex flex-col shadow-md
      relative; // So it drops shadow onto whatever is in the `before` slot if it is a positioned element.
    background-color: theme('colors.sidebar-bg');
  }

  .page-sidebar-logo {
    @apply block px-4 py-1 w-full shadow;
    height: var(--header-height);
    line-height: var(--header-height);

    img {
      @apply w-full h-full;
      object-fit: contain;
    }
  }

  @divider-margin: theme('margin.2');
  .page-sidebar-menu {
    @apply flex-grow
      // A hack to fix https://github.com/Grsmto/simplebar/issues/475
      h-full;
    min-height: 0; // Otherwise it overflows the container.

    .page-sidebar__categories-and-links-divider {
      @apply border-sidebar-text opacity-30;
      margin-top: @divider-margin;
      margin-bottom: @divider-margin;
    }
  }

  &__other-link {
    @margin-y: theme('margin.2');
    @apply block font-light text-sm mx-3 text-sidebar-text;
    margin-top: @divider-margin;
    margin-bottom: @divider-margin;
    &:first-of-type {
      margin-top: calc(@divider-margin + @margin-y);
    }
    &:focus,
    &:hover,
    &.router-link-active {
      @apply text-primary outline-none;
    }
  }

  .sidebar-footer {
    @apply py-2 px-4 text-center bg-primary;
    width: theme('customVars.sidebar.width');

    ul {
      @apply -mt-1;

      li {
        @apply inline-block mr-1 mt-1;

        &:last-child {
          @apply mr-0;
        }

        a {
          @apply bg-primary w-8 h-8 text-white rounded border border-white flex items-center justify-center;

          &:hover {
            @apply bg-primary-dark;
          }
        }
      }
    }
  }
}

@screen theme('customVars.sidebar.moveLinksToHeaderBreakpoint') {
  .page-sidebar {
    &__categories-and-links-divider {
      @apply hidden;
    }
    &__other-link {
      @apply hidden;
    }
  }
}
</style>
